export default __webpack_public_path__ + "static/media/Alvazar's Gloves.473087a4.jpg";